import * as React from "react";
import {
  Grid,
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Slider,
  TextField,
} from "@material-ui/core";

import Moment from "moment";

export default function Goals({ handleClose, open }) {
  const [range, setRange] = React.useState(30);
  return (
    <Grid item>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth="100%"
        className="m-0"
      >
        <DialogTitle id="form-dialog-title">
          <Typography variant="h6">ADD CAREER GOAL</Typography>
        </DialogTitle>
        <DialogContent>
          <input
            className="form-control h-auto py-2 px-6 my-3"
            autoFocus
            margin="dense"
            placeholder="Goal"
            type="text"
          />
          <TextField
            id="date"
            className="mt-4"
            label="Birthday"
            type="date"
            defaultValue={Moment("Wednesday, 17 August 2022").format(
              "YYYY-MM-DD"
            )}
            InputLabelProps={{
              shrink: true,
            }}
            // variant="outlined"
            color="primary"
            fullWidth
            onChange={(evt) => {}}
          />
          <Grid item xs>
            <p className="mt-5">Select Progress</p>
            <Slider
              value={range}
              onChange={(e, val) => setRange(val)}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
            />
          </Grid>
          <Grid
            className="mb-4 d-flex justify-content-between align-items-center"
            container
          >
            <h6>Progress</h6>
            <h6>{range}%</h6>
          </Grid>
          <Grid
            className="mb-4 d-flex justify-content-between align-items-center"
            container
          >
            <h5>Add Reminder</h5>
            <span className="switch switch-success switch-sm">
              <label>
                <input type="checkbox" onChange={() => {}} checked name="" />
                <span></span>
              </label>
            </span>
          </Grid>
          <h6 className="mt-5">
            I want to acquire a higher income by <br /> 1-Aug-2022
          </h6>
        </DialogContent>
        <DialogActions>
          <Grid className="px-5 mb-4" container direction="row">
            <Button
              type="button"
              className="px-10 m-auto AtBtnRed"
            >
              <Typography>Proceed</Typography>
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
